import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { IconDownload } from '@tabler/icons-react';
import { generatePatientEducationPDF } from './PatientEducationPdf';

function PatientEducation({ patientInfo }) {
  const sections = useMemo(() => {
    const sectionsObj = {};
    patientInfo?.Sections?.forEach((section) => {
      sectionsObj[section.Title] = section.Text;
    });
    return sectionsObj;
  }, [patientInfo]);

  return (
    <>
      <div className="mb-36 scroll-offset" id="disclaimer-section">
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="mb-3"> Patient Education</h4>
          <button
            type="button"
            className="btn download-btn"
            onClick={() => generatePatientEducationPDF(patientInfo)}
          >
            <IconDownload
              className="icon icon-tabler icons-tabler-outline icon-tabler-download"
              width="18"
              height="18"
              viewBox="0 0 24 24"
            />
            Download
          </button>
        </div>
        <div className="accordion-body">
          <div className="drugsearch-content ">
            <h3>Disclaimer</h3>
            {sections['Disclaimer'] ? (
              <p>{sections['Disclaimer']}</p>
            ) : (
              <p className="fst-italic text-muted">Disclaimer information not provided by source</p>
            )}
          </div>
          <div className="row">
            <div className=" col-sm-6 col-md-4 col-12 drug-info">
              <label>Title</label>

              {sections['Monograph Title'] ? (
                <p>{sections['Monograph Title']}</p>
              ) : (
                <p className="fst-italic text-muted">Title not provided in patient materials</p>
              )}
            </div>
            <div className=" col-sm-6 col-12 drug-info">
              <label>Phonetic Pronunciation</label>
              {sections['Phonetic Pronunciation'] ? (
                <p>{sections['Phonetic Pronunciation']}</p>
              ) : (
                <p className="fst-italic text-muted">Pronunciation guide not available</p>
              )}
            </div>
            <div className=" col-sm-6 col-12 drug-info mb-0">
              <label>Common Brand Name</label>
              {sections['Common Brand Name'] ? (
                <p>{sections['Common Brand Name']}</p>
              ) : (
                <p className="fst-italic text-muted">Brand names not listed for this medication</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="warning-section">
        <h4 className="">Warning</h4>
        <div>
          <div className="accordion-body">
            <div className="drugsearch-content">
              {sections['Warning'] ? (
                <p>{sections['Warning']}</p>
              ) : (
                <p className="fst-italic text-muted">Warning information not available from source</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="uses-section">
        <h4 className="accordion-header">Uses</h4>
        <div>
          <div className="accordion-body">
            <div className="drugsearch-content">
              {sections['Uses'] ? (
                <p>{sections['Uses']}</p>
              ) : (
                <p className="fst-italic text-muted">Usage information not included in patient materials</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mb-36 scroll-offset" id="how-to-use-section">
        <h4 className="accordion-header">How to Use</h4>
        <div>
          <div className="accordion-body">
            <div className="drugsearch-content">
              {sections['Side Effects'] ? (
                <p>{sections['Side Effects']}</p>
              ) : (
                <p className="fst-italic text-muted">Administration instructions not included in patient materials</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="education-side-effects-section">
        <h4 className="accordion-header"> Side Effects</h4>
        <div>
          <div className="accordion-body">
            <div className="drugsearch-content">
              {sections['Side Effects'] ? (
                <p>{sections['Side Effects']}</p>
              ) : (
                <p className="fst-italic text-muted">Side effects information not available from source</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="precautions-section">
        <h4 className="accordion-header">Precautions</h4>
        <div>
          <div className="accordion-body">
            <div className="drugsearch-content">
              {sections['Precautions'] ? (
                <p>{sections['Precautions']}</p>
              ) : (
                <p className="fst-italic text-muted">Precautions not included in patient materials</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="drug-interactions-section">
        <h4 className="accordion-header">Drug Interactions</h4>
        <div>
          <div className="accordion-body">
            <div className="drugsearch-content">
              {sections['Drug Interactions'] ? (
                <p>{sections['Drug Interactions']}</p>
              ) : (
                <p className="fst-italic text-muted">Drug interaction information not provided in patient materials</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="overdose-section">
        <h4 className="accordion-header">Overdose</h4>
        <div>
          <div className="accordion-body">
            <div className="drugsearch-content">
              {sections['Overdose'] ? (
                <p>{sections['Overdose']}</p>
              ) : (
                <p className="fst-italic text-muted">Overdose information not available from source</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="missed-dose-section">
        <h4 className="accordion-header"> Missed Dose</h4>
        <div>
          <div className="drugsearch-content">
            {sections['Missed Dose'] ? (
              <p>{sections['Missed Dose']}</p>
            ) : (
              <p className="fst-italic text-muted">Missed dose guidance not included in patient materials</p>
            )}
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="storage-section">
        <h4 className="accordion-header">Storage</h4>
        <div>
          <div className="accordion-body">
            <div className="drugsearch-content">
              {sections['Storage'] ? (
                <p>{sections['Storage']}</p>
              ) : (
                <p className="fst-italic text-muted">Storage instructions not included in patient materials</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-36 scroll-offset" id="notes-section">
        <h4 className="accordion-header">Notes</h4>
        <div>
          <div className="drugsearch-content">
            {sections['Notes'] ? (
              <p>{sections['Notes']}</p>
            ) : (
              <p className="fst-italic text-muted">Additional notes not included in patient materials</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

PatientEducation.propTypes = {
  patientInfo: PropTypes.object.isRequired,
};

PatientEducation.displayName = 'PatientEducation';
export default PatientEducation;
